export default "__VITE_ASSET__D4ZUNZ_H__"